import React from "react";

/**
 * Bootstrap-styled Badge component.
 */
export const Badge = ({
  variant = "default",
  className = "",
  children,
  ...props
}) => {
  const getVariantClass = (variant) => {
    switch (variant) {
      case "secondary":
        return "bg-secondary text-white";
      case "destructive":
        return "bg-danger text-white";
      case "outline":
        return "border border-secondary text-secondary bg-transparent";
      case "default":
      default:
        return "";
    }
  };

  return (
    <span
      className={`badge ${getVariantClass(variant)} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};
